import { render, staticRenderFns } from "./SOV4Detailed.vue?vue&type=template&id=24632336&scoped=true"
import script from "./SOV4Detailed.vue?vue&type=script&lang=js"
export * from "./SOV4Detailed.vue?vue&type=script&lang=js"
import style0 from "./SOV4Detailed.vue?vue&type=style&index=0&id=24632336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24632336",
  null
  
)

export default component.exports